import { c as _c } from "react/compiler-runtime";
import useCartDiscount from '@/contexts/cartContext/hooks/useCartDiscount';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { Error } from '@winelidays/wld-tsx-2/elements';
import { AccordionItem } from '@winelidays/wld-tsx-2/modules';
import { useState } from 'react';
import DiscountContent from './DiscountContent';
import DiscountForm from './DiscountForm';
const DiscountCodeForm = () => {
    const $ = _c(24);
    const translate = useTranslate();
    const { discount, discountCodeError } = useCartDiscount();
    const [isOpen, setIsOpen] = useState(false);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = () => {
            setIsOpen(_temp);
        };
        $[0] = t0;
    }
    else {
        t0 = $[0];
    }
    const toggleIsOpen = t0;
    let t1;
    if ($[1] !== translate) {
        t1 = translate("cart_page.discount_form.title");
        $[1] = translate;
        $[2] = t1;
    }
    else {
        t1 = $[2];
    }
    let t2;
    if ($[3] !== t1) {
        t2 = <p className="text-base">{t1}</p>;
        $[3] = t1;
        $[4] = t2;
    }
    else {
        t2 = $[4];
    }
    let t3;
    if ($[5] !== translate) {
        t3 = translate("cart_page.discount_form.subtitle");
        $[5] = translate;
        $[6] = t3;
    }
    else {
        t3 = $[6];
    }
    let t4;
    if ($[7] !== t3) {
        t4 = <p className="text-xs text-gray-400">{t3}</p>;
        $[7] = t3;
        $[8] = t4;
    }
    else {
        t4 = $[8];
    }
    let t5;
    if ($[9] !== t2 || $[10] !== t4) {
        t5 = <>{t2}{t4}</>;
        $[9] = t2;
        $[10] = t4;
        $[11] = t5;
    }
    else {
        t5 = $[11];
    }
    const label = t5;
    let t6;
    if ($[12] !== discount) {
        t6 = discount ? <DiscountContent {...discount}/> : <DiscountForm />;
        $[12] = discount;
        $[13] = t6;
    }
    else {
        t6 = $[13];
    }
    const discountContent = t6;
    let t7;
    if ($[14] !== discountCodeError || $[15] !== translate) {
        t7 = discountCodeError ?
            <Error>{translate("error.discount_code.invalid")}</Error> : null;
        $[14] = discountCodeError;
        $[15] = translate;
        $[16] = t7;
    }
    else {
        t7 = $[16];
    }
    const discountError = t7;
    let t8;
    if ($[17] !== discountContent || $[18] !== discountError) {
        t8 = <>
      {discountContent}
      {discountError}</>;
        $[17] = discountContent;
        $[18] = discountError;
        $[19] = t8;
    }
    else {
        t8 = $[19];
    }
    let t9;
    if ($[20] !== isOpen || $[21] !== label || $[22] !== t8) {
        t9 = <AccordionItem _key="discount" isOpen={isOpen} onClick={toggleIsOpen} label={label} className="!border-t-0 tunnel-margin-x-reduced-lg mb-6" noLi={true} forceAccordionOpen={false}>{t8}
    </AccordionItem>;
        $[20] = isOpen;
        $[21] = label;
        $[22] = t8;
        $[23] = t9;
    }
    else {
        t9 = $[23];
    }
    return t9;
};
export default DiscountCodeForm;
function _temp(c) { return !c; }
